export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1200&q=80",
  hotel: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=960&q=80",
  stage: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=960&q=80",
  riverside: "https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=960&q=80",
  spend: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80"
};

export const DEMO_BALANCE = "£125.00";
export const DEMO_ACTIVATION_CODE = "NB-482917";
export const DEMO_HOTEL_ADDRESS = "12 Riverside Walk\nLangbourne\nLondon SE1 9AB";
